import { NgModule } from '@angular/core';
import { DisableControlDirective } from './disable-control/disable-control.directive';
import { RestrictInputDirective } from './restrict-input/restrict-input.directive';
@NgModule({
    declarations: [
        DisableControlDirective,
        RestrictInputDirective
    ],
    imports: [],
    exports: [
        DisableControlDirective,
        RestrictInputDirective
    ]
})
export class SharedDirectivesModule {
}
